import NewCoachModal from './NewCoachModal';

export default NewCoachModal;
